import { orderInformationStyles } from "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsOrderInformation";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

orderInformationStyles.orderNumberGridItem = {
   width: [6,6,6,3,3],
    css: css`
        flex-direction: column;
        ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(theme, [
            css`
                padding-bottom: 5px;
            `,
            css`
                padding-bottom: 5px;
            `,
            css``,
            css``,
            css``,
        ])}
    `,
}

orderInformationStyles.orderDateGridItem = {
    width: [6,6,6,3,3],
    css: css`
        flex-direction: column;
        ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(theme, [
            css`
                padding-bottom: 5px;
            `,
            css`
                padding-bottom: 5px;
            `,
            css``,
            css``,
            css``,
        ])}
    `,
}

orderInformationStyles.poNumberGridItem = {
    width: [6,6,6,3,3],
    css: css`
        flex-direction: column;
        ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(theme, [
            css`
                padding-bottom: 30px;
            `,
            css`
                padding-bottom: 30px;
            `,
            css``,
            css``,
            css``,
        ])}
    `,
}

orderInformationStyles.statusGridItem = {
    width: [6,6,6,3,3],
    css: css`
        flex-direction: column;
        ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(theme, [
            css`
                padding-bottom: 30px;
            `,
            css`
                padding-bottom: 30px;
            `,
            css``,
            css``,
            css``,
        ])}
    `,
}